import { Type } from 'class-transformer';
import {
  IsObject,
  IsUUID,
  ValidateBy,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { FormSubmissionBlobDto } from '../forms/form-submission.dtos';

/**
 * The rich flow's dynamic-form payload, written through the triage. On submit
 * (`draft: false` on the triage) the blob is validated and pruned; while drafting
 * it is stored as-is. Carries no patient anchor — the triage already owns that.
 */
export class ConditionTriageFormSubmissionDto {
  /**
   * The exact template version the submission is validated against and pinned
   * to — the `id` of the template the client fetched for rendering. Required
   * unless a released client sends only {@link formTemplateId}.
   */
  @ValidateIf((dto) => dto.formTemplateId == null)
  @IsUUID()
  formTemplateVersionId?: string;

  /** @deprecated Use formTemplateVersionId */
  @ValidateIf((dto) => dto.formTemplateId != null)
  @IsUUID()
  @ValidateBy({
    name: 'matchesFormTemplateVersionId',
    validator: {
      validate: (value, args) => {
        const pinned = (args?.object as ConditionTriageFormSubmissionDto)
          .formTemplateVersionId;
        return pinned == null || pinned === value;
      },
      defaultMessage: () =>
        'formTemplateId must equal formTemplateVersionId when both are sent',
    },
  })
  formTemplateId?: string;

  @IsObject()
  @ValidateNested()
  @Type(() => FormSubmissionBlobDto)
  submission: FormSubmissionBlobDto;
}
